/**
 * Internal dependencies
 */
import {
    CURRENT_RETAILER_RENTAL_RECEIVE,
    CURRENT_RETAILER_RENTAL_REQUEST,
    CURRENT_RETAILER_RENTAL_REQUEST_SUCCESS,
    CURRENT_RETAILER_RENTAL_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentRetailerRental, requestingCurrentRetailerRental} from 'state/current-retailer-rental/selectors';

export const setCurrentRetailerRental = (retailerRental) => {
    return {
        type: CURRENT_RETAILER_RENTAL_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentRetailerRental = () => (dispatch) => {
    dispatch({
        type: CURRENT_RETAILER_RENTAL_REQUEST,
    });

    return cscom
        .currentRetailerRental()
        .list()
        .then((retailerRental) => {
            dispatch({
                type: CURRENT_RETAILER_RENTAL_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_RETAILER_RENTAL_RECEIVE,
                payload: {
                    retailerRental,
                },
            });
            return retailerRental;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_RETAILER_RENTAL_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_RETAILER_RENTAL_REQUEST_FAILURE,
                error,
            });
        });
};

export const requestCurrentRetailerRentalIfNotRequested = (...props) => async (dispatch, getState) => {
    
    const currentRetailerRental = getCurrentRetailerRental(getState());
    const requesting = requestingCurrentRetailerRental(getState());

    if (!currentRetailerRental && requesting == false) {
        return dispatch(requestCurrentRetailerRental(...props))
    }

    return currentRetailerRental;
}

